import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import {
  getProductsByCategory,
  groupBySubcategory,
} from "../../catalog-item-list/helpers";

export const useFavourite = (
  categories,
  catalog,
  searchText,
  filteredCatalog,
  delivery,
  setDelivery,
  search,
) => {
  const [productsByCategory, setProductByCategory] = useState({});
  const [filteredProductsByCategory, setFilteredProductsByCategory] = useState(
    {},
  );
  const [isCatalogEmpty, setIsCatalogEmpty] = useState(false);
  const intl = useIntl();

  const favouritesTranslated = intl.formatMessage({ id: "favourites" });
  const allTranslated = intl.formatMessage({ id: "all" });
  const searchResultsTranslated = intl.formatMessage({ id: "searchResults" });
  const otherTranslated = intl.formatMessage({ id: "other" });

  const updateCartDelivery = (id) => {
    const newDelivery = { ...delivery };
    newDelivery.orders.map((i) => {
      if (i.deliver_listing.id == id) {
        i.is_favourite = !i.is_favourite;
      }
    });
    setDelivery(newDelivery);
  };

  const onFavouriteAddRemove = (id, state, categoryId, subCategoryId) => {
    updateCartDelivery(id);
    let givenItem = null;
    let itemCategory = null;
    const tempProductsByCategory = { ...productsByCategory };
    const tempFilteredProductsByCategory = { ...filteredProductsByCategory };

    [tempProductsByCategory, tempFilteredProductsByCategory].forEach(
      (productSet) => {
        Object.keys(productSet).forEach((category) => {
          Object.keys(productSet[category]).forEach((subCategory) => {
            if (category === favouritesTranslated && state === "remove") {
              const filteredItems = productSet[category][subCategory].filter(
                (item) => item && item.id !== id,
              );
              productSet[category][subCategory] = filteredItems;
            }
            productSet[category][subCategory].forEach((item) => {
              if (item && item.id === id) {
                item.is_favourite = state === "add";
                givenItem = item;
                if (category !== favouritesTranslated) {
                  itemCategory = category;
                }
              }
            });
          });
        });
      },
    );

    if (state === "add") {
      const categoryToUse = itemCategory ;

      [tempProductsByCategory, tempFilteredProductsByCategory].forEach(
        (productSet) => {
          if (!productSet[favouritesTranslated]) {
            productSet[favouritesTranslated] = {};
          }
          
          if (!productSet[favouritesTranslated][categoryToUse]) {
            productSet[favouritesTranslated][categoryToUse] = [];
          }
          const alreadyExists = productSet[favouritesTranslated][categoryToUse].some(
            item => item && item.id === givenItem.id
          );
          
          if (!alreadyExists) {
            productSet[favouritesTranslated][categoryToUse] = [
              ...productSet[favouritesTranslated][categoryToUse],
              { ...givenItem, is_favourite: true },
            ];
          }
        },
      );
    }

    setProductByCategory(tempProductsByCategory);
    setFilteredProductsByCategory(tempFilteredProductsByCategory);
  };

  useEffect(() => {
    if (searchText !== "") {
      const resultantCatalog = filteredCatalog
        ? search(searchText).filter((listing) => !listing.deliver_listing)
        : [];
      setIsCatalogEmpty(!resultantCatalog.length);

      const allCategoriesWithProducts = getProductsByCategory(
        categories,
        catalog.filter((listing) => !listing.deliver_listing),
        favouritesTranslated,
        otherTranslated,
      );

      const searchResultsStructure = {};
      searchResultsStructure[searchResultsTranslated] = {};

      resultantCatalog.forEach((product) => {
        const mainCategory = product.categories[0]?.category || otherTranslated;
        if (!searchResultsStructure[searchResultsTranslated][mainCategory]) {
          searchResultsStructure[searchResultsTranslated][mainCategory] = [];
        }
        searchResultsStructure[searchResultsTranslated][mainCategory].push(
          product,
        );
      });

      const tempProductsByCategory = {
        ...allCategoriesWithProducts,
        ...searchResultsStructure,
      };

      groupBySubcategory(
        tempProductsByCategory,
        favouritesTranslated,
        allTranslated,
      );
      setFilteredProductsByCategory(tempProductsByCategory);
    } else {
      const filteredCatalog = catalog
        ? catalog.filter((listing) => !listing.deliver_listing)
        : [];
      setIsCatalogEmpty(!filteredCatalog.length);

      const tempProductsByCategory = getProductsByCategory(
        categories,
        filteredCatalog,
        favouritesTranslated,
        otherTranslated,
      );
      groupBySubcategory(
        tempProductsByCategory,
        favouritesTranslated,
        allTranslated,
      );
      setProductByCategory(tempProductsByCategory);
    }
  }, [catalog, searchText]);

  return {
    isCatalogEmpty,
    productsByCategory: searchText
      ? filteredProductsByCategory
      : productsByCategory,
    filteredProductsByCategory,
    setProductByCategory,
    onFavouriteAddRemove,
    delivery,
    setDelivery,
  };
};
